export default [
  {
    path: '/admin/leave-rules',
    name: 'leave-rule',
    meta: { requiresAuth: true },
    component: () => import('@/pages/human-resource/leave-rule')
  }
]
